module.exports = __webpack_public_path__ + "img/0-126.f7a6fdbb.jpg";